// extracted by mini-css-extract-plugin
module.exports = {"imgNav":"Navbar_imgNav__3JXVM","navText":"Navbar_navText__1a9o9","imgLogo":"Navbar_imgLogo__1JO2d"};